<div *ngIf='screenWidth > 1230'>

<div >
<div class="bmw-lg-results-side-bar-content">
  <div class="row bmw-no-gutter">Show results for </div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'all']" [ngClass]="{'active':section==='all'}" (click)='sendSelectedSectionToHeader("All")'>All</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'sib']" [ngClass]="{'active':section==='sib'}" (click)='sendSelectedSectionToHeader("SIB")'>Service Bulletins</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'pbs']" [ngClass]="{'active':section==='pbs'}" (click)='sendSelectedSectionToHeader("PBS")'>Parts Bulletins</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'tm']" [ngClass]="{'active':section==='tm'}" (click)='sendSelectedSectionToHeader("TM")'>Training Manuals</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'faq']" [ngClass]="{'active':section==='faq'}" (click)='sendSelectedSectionToHeader("FAQ")'>FAQ</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'obd']" [ngClass]="{'active':section==='obd'}" (click)='sendSelectedSectionToHeader("OBD")'>OBD</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'te']" [ngClass]="{'active':section==='te'}" (click)='sendSelectedSectionToHeader("TE")'>Tools & Equipment</a></div>
  <div *ngIf="isExternal === 'false'" class="row bmw-no-gutter"><a [routerLink]="['/results', 'td']" [ngClass]="{'active':section==='td'}" (click)='sendSelectedSectionToHeader("TD")'>Technical Documentation</a></div>
</div>
<div class="bmw-lg-results-side-bar-filterby">
  <div class="row bmw-no-gutter">Filter by</div>
  <div class="row bmw-no-gutter">
    <div class="row bmw-no-gutter">Main Group</div>
    <div class="row bmw-no-gutter">
      <select #selectMainGroup [(ngModel)]='selectGroup' [disabled]='!(section==="sib" || section==="tri" || section==="all")'>
        <option *ngFor='let group of mainGroupList' [ngValue]='group'>{{group}}</option>
      </select>
      <span style="color:#d20000">{{noMainGroupError}}</span>
    </div>
  </div>
  <div class="row bmw-no-gutter">
    <div class="row bmw-no-gutter">Series</div>
    <div class="row bmw-no-gutter">
      <input [(ngModel)]='selectSeries' (focusout)='changeSeriesInput()' [disabled]='!(section==="sib" || section==="tri" || section==="all")'
        type="input" placeholder="Enter Series">
    </div>
  </div>
  <div class="row bmw-no-gutter">
    <div class="row bmw-no-gutter">Year Published</div>
    <div class="row bmw-no-gutter">
      <div class="row bmw-no-gutter">
        <div class="col-lg-3 bmw-no-gutter">
          From
        </div>
        <div class="col-lg-7 bmw-no-gutter">
          <select #selectFromYr [(ngModel)]='selectFromYear' [disabled]='(section==="of" || section==="te" || section==="tm" || section==="td"|| section==="lgc")'>
            <option *ngFor="let year of fromYears" [ngValue]="year">{{year}}</option>
          </select>
          <span style="color:#d20000">{{noFromYear}}</span>
        </div>

      </div>
      <div class="row bmw-no-gutter" style="margin-top:10px">
        <div class="col-lg-3 bmw-no-gutter">
          To
        </div>
        <div class="col-lg-7 bmw-no-gutter">
          <select [(ngModel)]='selectToYear' [disabled]='(section==="of" || section==="te" || section==="tm" || section==="td"|| section==="lgc")'>
            <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
          </select>
          <span style="color:#d20000">{{noToYear}}</span>
        </div>

      </div>
    </div>
  </div>
  <div class="row bmw-no-gutter">
    <div class="col-lg-6 bmw-no-gutter">
      <button class="bmw-search-filter-button" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' type="button" (click)='clearFilter()'>Clear Filter</button>
    </div>
    <div class="col-lg-6 bmw-no-gutter">
      <button class="bmw-search-filter-button" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' type="button" (click)='applyFilter()'>Apply Filter</button>
    </div>
  </div>
</div>
</div>
</div>
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>

<div >
<div class="bmw-lg-results-side-bar-content">
  <div class="row bmw-no-gutter">Show results for</div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'all']" [ngClass]="{'active':section==='all'}" (click)='sendSelectedSectionToHeader("All")'>All</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'sib']" [ngClass]="{'active':section==='sib'}" (click)='sendSelectedSectionToHeader("SIB")'>Service Bulletins</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'pbs']" [ngClass]="{'active':section==='pbs'}" (click)='sendSelectedSectionToHeader("PBS")'>Parts Bulletins</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'of']" [ngClass]="{'active':section==='of'}" (click)='sendSelectedSectionToHeader("OF")'>Operating Fluids</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'tm']" [ngClass]="{'active':section==='tm'}" (click)='sendSelectedSectionToHeader("TM")'>Training Manuals</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'noi']" [ngClass]="{'active':section==='noi'}" (click)='sendSelectedSectionToHeader("NOI")'>>Noise Catalog</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'vid']" [ngClass]="{'active':section==='vid'}" (click)='sendSelectedSectionToHeader("VID")'>Videos</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'obd']" [ngClass]="{'active':section==='obd'}" (click)='sendSelectedSectionToHeader("OBD")'>OBD</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'te']" [ngClass]="{'active':section==='te'}" (click)='sendSelectedSectionToHeader("TE")'>Tools & Equipment</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'td']" [ngClass]="{'active':section==='td'}" (click)='sendSelectedSectionToHeader("TD")'>Technical Documentation</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'tkr']" [ngClass]="{'active':section==='tkr'}" (click)='sendSelectedSectionToHeader("TKR")'>Takata Recall</a></div>
  <div class="row bmw-no-gutter"><a [routerLink]="['/results', 'lgc']" [ngClass]="{'active':section==='lgc'}" (click)='sendSelectedSectionToHeader("LGC")'>Legacy</a></div>
</div>
<div class="bmw-lg-results-side-bar-filterby">
  <div class="row bmw-no-gutter">Filter by</div>
  <div class="row bmw-no-gutter">
    <div class="row bmw-no-gutter">Main Group</div>
    <div class="row bmw-no-gutter">
      <select #selectMainGroup [(ngModel)]='selectGroup' [disabled]='!(section==="sib" || section==="tri" || section==="all")'>
            <option *ngFor='let group of mainGroupList' [ngValue]='group'>{{group}}</option>
          </select>
      <span style="color:#d20000">{{noMainGroupError}}</span>
    </div>
  </div>
  <div class="row bmw-no-gutter">
    <div class="row bmw-no-gutter">Series</div>
    <div class="row bmw-no-gutter">
      <input [(ngModel)]='selectSeries' (focusout)='changeSeriesInput()' [disabled]='!(section==="sib" || section==="tri" || section==="all")'
        type="input" placeholder="Enter Series">
    </div>
  </div>
  <div class="row bmw-no-gutter">
    <div class="row bmw-no-gutter">Year Published</div>
    <div class="row bmw-no-gutter">
      <div class="row bmw-no-gutter">
        <div class="col-md-3 bmw-no-gutter">
          From
        </div>
        <div class="col-md-7 bmw-no-gutter">
          <select #selectFromYr [(ngModel)]='selectFromYear' [disabled]='(section==="of" || section==="te" || section==="tm" || section==="td"|| section==="lgc")'>
                <option *ngFor="let year of fromYears" [ngValue]="year">{{year}}</option>
              </select>
          <span style="color:#d20000">{{noFromYear}}</span>
        </div>

      </div>
      <div class="row bmw-no-gutter" style="margin-top:10px">
        <div class="col-md-3 bmw-no-gutter">
          To
        </div>
        <div class="col-md-7 bmw-no-gutter">
          <select [(ngModel)]='selectToYear' [disabled]='(section==="of" || section==="te" || section==="tm" || section==="td"|| section==="lgc")'>
                <option *ngFor="let year of toYears" [ngValue]="year">{{year}}</option>
              </select>
          <span style="color:#d20000">{{noToYear}}</span>
        </div>

      </div>
    </div>
  </div>
</div>
</div>
</div>